import NProgress from "nprogress";
import debounce from "lodash.debounce";

const stopDebounce = debounce(() => NProgress.done(), NProgress.settings.speed);

const start = () => {
  stopDebounce.cancel();
  NProgress.start();
};

const stop = () => stopDebounce();

export default { start, stop };
